"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PipeStatusForOrdersApi = exports.PeriodAttributionApi = exports.PaginatedOrdersApi = void 0;
/** A v3 API result item representing a create, update, or get operation. */
/** A v3 API result item representing a delete operation. */
// We use a condition type here, because TypeScript distributes over union types, which means the ModelType will
// correctly correspond to the ModelName.
/** Type for `result` array sent via v3 APIs. */
/** Type for the response sent via v3 APIs. */
/** Base type for the data in a NATS message. */
/** One item in the data portion of a NATS message representing a single create, update, or get operation. */
/** One item in the data portion of a NATS message representing a single delete operation. */
/** The data portion of a NATS message, representing several create, update, get, and delete operations. */
/** The data portion of a NATS message, representing several create, update, get, and delete operations. */
/** Type for NATS messages. */
let PeriodAttributionApi = exports.PeriodAttributionApi = void 0;
let PaginatedOrdersApi = exports.PaginatedOrdersApi = void 0;
let PipeStatusForOrdersApi = exports.PipeStatusForOrdersApi = void 0;
/** These are types specifically for the paginated customer payments query endpoint. */